import RoutesMap from "../../route_control/RouteControl"
import {
    CustomerFreelancerLinkList,
    AddCustomerFreelancerLink,
    CustomerFreelancerLinkDetails,
} from "../../pages/customer_freelancer_link"

export const CustomerFreelancerLinkRouteImport = {
    RoutesMap,
    CustomerFreelancerLinkList,
    AddCustomerFreelancerLink,
    CustomerFreelancerLinkDetails,
}
